import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const DeleteIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon {...props} viewBox="0 0 16 18">
    <path
      d="M10.8611 3.95V3.31C10.8611 2.41392 10.8611 1.96587 10.6916 1.62362C10.5424 1.32256 10.3045 1.07779 10.0118 0.92439C9.67901 0.75 9.24342 0.75 8.37222 0.75H7.12778C6.25658 0.75 5.82099 0.75 5.48824 0.92439C5.19554 1.07779 4.95757 1.32256 4.80843 1.62362C4.63889 1.96587 4.63889 2.41392 4.63889 3.31V3.95M6.19444 8.35V12.35M9.30556 8.35V12.35M0.75 3.95H14.75M13.1944 3.95V12.91C13.1944 14.2541 13.1944 14.9262 12.9401 15.4396C12.7164 15.8912 12.3595 16.2583 11.9204 16.4884C11.4213 16.75 10.7679 16.75 9.46111 16.75H6.03889C4.7321 16.75 4.07871 16.75 3.57958 16.4884C3.14053 16.2583 2.78358 15.8912 2.55987 15.4396C2.30556 14.9262 2.30556 14.2541 2.30556 12.91V3.95"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);
